// import { useEffect, useRef } from "react";
// import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { SearchDropdown } from "../searchDropdown";

export const AutoCompleteInput = (props) => {
  const {
    label,
    errorMsg = "",
    options,
    onSelect,
    placeholder,
    defaultOption,
    disabled = false,
  } = props || {};

  // const formatResult = (item) => {
  //   return (
  //     <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
  //   );
  // };
  const isError = !!errorMsg || !defaultOption;

  return (
    <div className="flex flex-col w-[100%] z-2">
      {!!label && (
        <span className="text-gray-700 font-medium text-sm mb-1.5">
          {label}
        </span>
      )}
      <div>
        <SearchDropdown
          showCancel={true}
          dropdownOptions={options}
          onChangeSearchText={() => {}}
          onSelectOption={onSelect}
          // width={width}
          placeholder={placeholder}
          defaultValue={defaultOption}
          disabled={disabled}
        />
        {/* <ReactSearchAutocomplete
          showIcon={false}
          items={options}
          onSelect={onSelect}
          placeholder={placeholder}
          formatResult={formatResult}
          inputSearchString={defaultOption}
          styling={{
            zIndex: 1,
            borderRadius: "8px",
            border: "1px #D0D5DD solid",
            boxShadow: "none",
            placeholderColor: "#D0D5DD",
          }}
        /> */}
      </div>
      {isError && (
        <span className="text-red font-medium max-w-[352px] text-sm mt-1">
          {errorMsg}
        </span>
      )}
    </div>
  );
};
